import {Component, Input, OnInit} from '@angular/core';
import {useDefault} from '../../common/common';
import {DepositPolicy} from '../../api/model/reservation/rate/deposit-policy.model';
@Component({
  selector: 'deposit-policy',
  templateUrl: './deposit-policy.component.html',
  styleUrls: ['./deposit-policy.component.scss']
})
export class DepositPolicyComponent implements OnInit {
  @Input() messages;
  @Input() depositPolicy: DepositPolicy;
  policyText: string;

  ngOnInit() {
    if (this.depositPolicy) {
      this.policyText = useDefault(this.depositPolicy.description, this.messages['reservation.deposit.' + this.depositPolicy.type]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/deposit-policy/deposit-policy.component.ts